/*
 *
 * Notifications reducer
 *
 */

import { fromJS } from 'immutable';
import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from './constants';

export const initialState = fromJS({
  message: '',
  level: '',
  sticky: undefined,
  uid: undefined,
});

function notificationsReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_NOTIFICATION: {
      const { level, message, sticky, uid } = action;
      return state
        .set('level', level)
        .set('message', message)
        .set('sticky', sticky)
        .set('uid', uid);
    }
    case REMOVE_NOTIFICATION: {
      const { uid } = action;
      return state
        .set('message', '')
        .set('level', '')
        .set('sticky', undefined)
        .set('uid', uid);
    }
    default:
      return state;
  }
}

export default notificationsReducer;
